/* import __COLOCATED_TEMPLATE__ from './-textarea.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();